import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import styled, { css } from "styled-components";
import { Select } from "antd";
import { FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

interface SelectWrapperProps {
  $fontSize?: number;
  $height?: number;
}

interface StylesPaginationProps extends TEXT_SCALE_PROPS {
  $disabled?: boolean;
}

export const Styles = styled.div<{ totalCellHeader: number }>`
  width: 100%;
  &:has(.ag-force-vertical-scroll) {
    .wrapper-scroll-bar-vertical {
      display: flex !important;
    }
  }

  ${({ totalCellHeader }) =>
    Array.from({ length: totalCellHeader }, (_, i) => {
      const index = i + 1;
      const isLastCellAsScroll = index === totalCellHeader;
      return css`
        .ag-header-cell[aria-colindex="${index}"] {
          z-index: ${isLastCellAsScroll ? 0 : index};
        }
      `;
    })}
  .wrapper-scroll-bar-horizontal {
    display: flex;
    justify-content: end;
    width: 100%;
    position: absolute;
    z-index: 2;
    border-bottom: 1px solid #bcbcbc;
    background: #fff;
  }
  .wrapper-scroll-bar-vertical {
    display: none;
    align-items: end;
    z-index: 3;
    height: 100%;
  }

  .btn-group {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 10px;
    gap: 8px;

    button:not(.non_css) {
      min-width: 150px;

      &:nth-child(3) {
        min-width: 150px;
      }
    }

    .btn-clear {
      min-width: 150px;
    }
  }

  .ag-horizontal-left-spacer {
    opacity: 0;
  }

  .table-wrapper {
    border: 1px solid #bcbcbc;
    button:not(.non_css) {
      height: 32px;
      border-radius: 2px;
    }

    .ag-cell[col-id="index"] {
      padding: 0 !important;
    }

    .orderNumber {
      padding: none !important;
    }
  }

  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 16px;
    position: relative;
    z-index: 10;

    .btn-delete {
      cursor: pointer;
    }
  }
  .scroll-bar-vertical-viewport {
    width: 15px;
    overflow-y: auto;
    overflow-x: hidden;
    .scroll-bar-inner-container {
      width: 1px;
    }
  }
`;

export const TableWrapper = styled.div<{
  widthScrollVertical: number;
  heightScrollHorizontal: number;
  $bg_header?: string;
  $color_header?: string;
}>`
  width: 100%;
  .has-scroll-vertical {
    .ag-pinned-left-cols-container,
    .ag-pinned-left-header {
      margin-right: ${(props) => `${props.widthScrollVertical}px`};
    }
  }
  .ag-cell[col-id="__scroll_bar_vertical__"],
  .ag-header-cell[col-id="__scroll_bar_vertical__"] {
    padding: 0;
    opacity: 0;
  }

  .ag-root {
    overflow: auto;
    &:has(.ag-body-horizontal-scroll:not(.ag-hidden)) {
      .ag-header.ag-pivot-off {
        margin-bottom: ${(props) => `${props.heightScrollHorizontal}px`};
      }
    }
  }
  .ag-header-viewport {
    border-top: 1px solid #bcbcbc;
    z-index: -1;
  }

  .ag-body-horizontal-scroll {
    position: absolute;
    top: 37px;
    z-index: -1;
    opacity: 0;
  }

  .ag-body-horizontal-scroll-viewport,
  .ag-body-horizontal-scroll-container,
  .ag-body-horizontal-scroll {
    height: 15px !important;
    min-height: 15px !important;
    max-height: 15px !important;
  }

  .ag-body-viewport {
    overflow-y: scroll !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    touch-action: pan-y pan-x;
    scrollbar-width: none;
  }

  .ag-theme-alpine .ag-body-viewport::-webkit-scrollbar {
    width: 0; /* Width of the vertical scrollbar */
  }

  .ag-row-even {
    background-color: #efefef;
  }

  .ag-overlay-loading-wrapper {
    background-color: unset;
  }

  .ag-root-wrapper {
    border: none;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .ag-scrollbar-scrolling {
    // display: none !important;
    z-index: 1000;
  }

  .ag-center-cols-viewport {
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .ag-root-wrapper,
  .ag-root-wrapper-body,
  .ag-root,
  .ag-body-viewport {
    height: 100%;
  }

  .ag-header {
    border-bottom: 1px solid #bcbcbc;
    position: relative;
    z-index: 3;
  }

  .ag-body-viewport {
    position: relative;
    z-index: 2;
    background-color: #fff;

    &:focus-within {
      z-index: 10 !important;
    }
  }

  .table-no-header {
    .ag-header-viewport {
      border-top: none !important;
    }
  }

  // .ag-header-viewport {
  //   border-top: 1px solid #bcbcbc;
  // }

  .ag-header-cell:not(.ag-header-cell-auto-height) {
    .ag-header-cell-comp-wrapper {
      background-color: ${({ $bg_header }) => $bg_header || "#ffffff"};
      .ag-header-cell-text {
        color: ${({ $color_header }) => $color_header || "#777777"};
      }
      .ag-icon::before {
        color: ${({ $color_header }) => $color_header || "#777777"};
      }
    }
  }

  .ag-pinned-right-header {
    border-top: 1px solid #bcbcbc;
    border-left: 1px solid #bcbcbc !important;

    .ag-header-cell-label {
      justify-content: center;
    }
  }

  .ag-pinned-left-header {
    border-right: 1px solid #bcbcbc !important;
    border-top: 1px solid #bcbcbc;
  }

  .ag-pinned-left-cols-container {
    border-right: 1px solid #bcbcbc;

    .ag-cell {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .btn-edit {
      color: #174a83;
      cursor: pointer;
      border-radius: 4px;
      height: 22px;
      width: 22px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .ag-pinned-right-cols-container {
    border-left: 1px solid #bcbcbc;
  }

  .ag-floating-filter-button {
    display: none;
  }

  .ag-header-cell,
  .ag-header-group-cell {
    padding-left: 0;
    padding-right: 0;
    background-color: #ffffff;
  }

  .ag-header-group-cell-label,
  .ag-header-cell-label {
    padding: 0 10px;
  }

  .ag-header-cell-label {
    justify-content: space-between;
  }

  .ag-ltr .ag-header-select-all {
    margin-left: 18px;
  }

  .ag-header-icon,
  .hidden-ag-icon .ag-icon {
    display: none;
  }

  .ag-icon {
    &.ag-icon-none {
      display: block;

      &::before {
        color: #777777;
      }
    }
  }

  .ag-icon-asc,
  .ag-icon-desc {
    display: block;

    &::before {
      color: #777777;
    }
  }

  .ag-header-row {
    &.ag-header-row-column-filter {
      background-color: #ffffff;
    }
  }

  .ag-header-cell {
    .floatingFilter-select {
      border-bottom: 1px solid #c9c9c9;
      padding-top: 20px;
      height: 44px;

      select {
        color: #777777;
        font-size: 15px;
        border: none;

        &:focus {
          border: none;
          outline: none;
        }
      }
    }
    &[col-id="index"],
    &[aria-colindex="1"] {
      border-left: none;
    }

    &:hover {
      background-color: #ffffff !important;
    }

    &.ag-floating-filter {
      border-top: 1px solid #bcbcbc !important;
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .ag-row {
    border-bottom: 1px solid #bcbcbc !important;
    /* background-color: #ffffff !important ; */

    &.ag-row-even,
    &.ag-row-odd {
      &.ag-row-last.ag-row-position-absolute {
        border-bottom: 1px solid #bcbcbc;
      }
    }

    &.ag-row-hover {
      &::before {
        background-color: #d3e4f4 !important;
      }
    }
  }

  .ag-input-field-input {
    border: none !important;
    border-bottom: 1px solid #c9c9c9 !important;
    border-radius: 0 !important ;
    position: relative;

    &.ag-text-field-input {
      font-weight: 500;
      font-size: 15px;

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }

  .ag-header-cell-text {
    color: #777777;
    font-weight: 600;
    font-size: 15px;
  }

  .ag-ltr .ag-cell-focus:not(.ag-cell-range-selected):focus-within {
    border-color: #bcbcbc !important;
    border-top: none;
    border-bottom: none;
    border-right: none;
  }

  .grid-cell-centered {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .ag-pinned-left-cols-container,
  .ag-pinned-left-header {
    margin-right: 2px;
  }

  .ag-header-cell {
    border-left: 1px solid #bcbcbc;
  }

  .ag-ltr {
    .ag-cell {
      line-height: auto !important;
      font-weight: 500;
      font-size: 15px;
      border: none;
      border-left: 1px solid #bcbcbc;

      &[col-id="index"] {
        border-left: none;
      }

      > button {
        border-radius: 8px;
        line-height: 44px;
        height: 32px;
        min-width: 78px;
      }

      &:focus {
        outline: none !important;
        box-shadow: none !important;
      }
    }
  }

  .ag-cell-value,
  .ag-group-value {
    display: block;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .ag-cell {
    min-width: 0;
  }

  input[type="checkbox"] {
    cursor: pointer;

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  .ag-wrapper.ag-input-wrapper.ag-checkbox-input-wrapper {
    border: 1px solid #777777;
    box-sizing: content-box;
  }

  .ag-checkbox-input-wrapper:focus-within,
  .ag-checkbox-input-wrapper:active {
    box-shadow: none;
  }

  .ag-checkbox-input-wrapper.ag-indeterminate::after {
    background-color: #000000;
    color: #ffffff;
  }

  .ag-checkbox-input-wrapper::after {
    background-color: #ffffff;
    border-radius: 6px;
    color: #ffffff;
  }

  .ag-checkbox-input-wrapper.ag-checked::after {
    color: #ffffff;
    background-color: #000000;
    border-radius: 6px;
  }

  .ag-paging-panel.ag-unselectable {
    display: none;
  }

  .ag-header-cell-text {
    overflow: initial;
    text-overflow: unset;
    white-space: normal !important;
  }

  .ag-overlay-wrapper.ag-layout-normal.ag-overlay-no-rows-wrapper {
    color: #777777;
    opacity: 0.8;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    pointer-events: none;
  }

  .cell-checkbox {
    .ant-checkbox-inner {
      height: 20px;
      width: 20px;
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #174a83 !important;
      border-color: #174a83 !important;
    }

    .ant-checkbox-disabled .ant-checkbox-inner {
      background-color: #f5f5f5;
    }

    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner:after {
      border-color: #fff;
    }

    .ant-checkbox-inner:after {
      top: 47.5%;
      left: 28.5%;
    }
  }

  .ag-body-horizontal-scroll.ag-scrollbar-invisible.ag-apple-scrollbar {
    display: inherit;
  }

  @media screen and (max-width: 768px) {
    .ag-root {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }

    .ag-body-viewport {
      overflow-y: auto !important;
      overflow-x: auto !important;
      overscroll-behavior-y: contain;
      overscroll-behavior-x: contain;
      touch-action: pan-x pan-y;
    }

    .ag-input-field-input.ag-text-field-input {
      font-size: 16px;
    }

    .ag-header-cell .floatingFilter-select select {
      font-size: 16px;
    }
  }
`;

export const SelectWrapper = styled(Select)<SelectWrapperProps>`
  font-size: ${({ $fontSize }) => ($fontSize ? `${$fontSize}px` : "15px")};
  &:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
  }

  .ant-select-focused:not(.ant-select-disabled)&:not(.ant-select-customize-input)
    .ant-select-selector {
    box-shadow: none;
    border: none;
  }
  .ant-select-selector {
    height: ${({ $height }) => ($height ? `${$height}px !important` : "32px")};
  }
`;

export const StylesPagination = styled.div<StylesPaginationProps>`
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};

  .ant-pagination-item {
    min-width: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "30px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "25px"
        : "22px"} !important;
    height: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "30px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "25px"
        : "22px"} !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    a {
      text-align: center;
    }
  }
  margin-left: 8px;
  .ant-pagination-item.ant-pagination-item-active {
    background-color: #1e3665 !important;
    border-color: #1e3665 !important;
  }
  .ant-pagination.ant-pagination-disabled .ant-pagination-item-active a {
    color: #fff;
  }

  .ant-pagination {
    display: flex;
    align-items: center;
    justify-content: center;

    .ant-pagination-options {
      display: none !important;
    }
  }

  .ant-select-arrow {
    margin-top: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "-5px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "-5px"
        : "-3px"} !important;
  }

  .ant-pagination-item a {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    display: flex;
    align-items: center;
  }

  .ant-select-item-option-content,
  .ant-select-selection-item {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;
  }
  .ant-select-arrow {
    align-items: center !important;
  }
  .pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    .ant-pagination-jump-next
      .ant-pagination-item-container
      .ant-pagination-item-link-icon,
    .ant-pagination-jump-prev
      .ant-pagination-item-container
      .ant-pagination-item-link-icon {
      color: #1e3665;
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      min-width: fit-content !important;
      width: ${({ text_scale }) =>
        text_scale?.includes(DISPLAY_SIZES.LARGE)
          ? "30px"
          : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
          ? "25px"
          : "22px"} !important;
      height: ${({ text_scale }) =>
        text_scale?.includes(DISPLAY_SIZES.LARGE)
          ? "30px"
          : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
          ? "25px"
          : "22px"} !important;
    }

    .ant-pagination-prev .ant-pagination-item-link,
    .ant-pagination-next .ant-pagination-item-link {
      min-width: ${({ text_scale }) =>
        text_scale?.includes(DISPLAY_SIZES.LARGE)
          ? "30px"
          : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
          ? "25px"
          : "22px"} !important;
      height: ${({ text_scale }) =>
        text_scale?.includes(DISPLAY_SIZES.LARGE)
          ? "30px"
          : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
          ? "25px"
          : "22px"} !important;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .select {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-weight: 700;
      font-size: 15px;

      .ant-select-selector {
        background: rgb(255, 255, 255);
      }
    }
  }
`;
